class Textarea {
    constructor(element) {
        this.element = element; // is my textarea
        this.textarea_field = this.element.querySelector(".form__textarea-field")
        this.label = this.element.querySelector(".form__label");

        this.textarea_field.addEventListener("input", () => this.addFilledClass());
    }

    addFilledClass () {
        if (this.textarea_field.value.trim() !== '') {
            this.element.classList.add('form__textarea--filled');
        } else {
            this.element.classList.remove('form__textarea--filled');
        }
    }
}

export default Textarea;